var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.7568C7.50803 19.7568 3.20705 16.452 0.368032 13.021C-0.122596 12.428 -0.122596 11.5673 0.368032 10.9743C1.08183 10.1117 2.57768 8.44738 4.5759 6.99287C9.60882 3.32948 14.3815 3.32241 19.4242 6.99287C21.7717 8.70159 23.632 10.9423 23.632 10.9743C24.1226 11.5673 24.1226 12.428 23.632 13.0209C20.7934 16.4515 16.493 19.7568 12 19.7568ZM12 5.71644C7.02382 5.71644 2.71019 10.462 1.50669 11.9165C1.4678 11.9635 1.4678 12.0318 1.50669 12.0788C2.71024 13.5333 7.02382 18.2789 12 18.2789C16.9762 18.2789 21.2899 13.5333 22.4934 12.0788C22.5635 11.994 22.4887 11.9165 22.4934 11.9165C21.2898 10.462 16.9762 5.71644 12 5.71644Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1707C9.14771 17.1707 6.82721 14.8502 6.82721 11.998C6.82721 9.14569 9.14771 6.8252 12 6.8252C14.8523 6.8252 17.1728 9.14569 17.1728 11.998C17.1728 14.8502 14.8523 17.1707 12 17.1707ZM12 8.30313C9.96265 8.30313 8.30514 9.96063 8.30514 11.998C8.30514 14.0353 9.96265 15.6928 12 15.6928C14.0373 15.6928 15.6948 14.0353 15.6948 11.998C15.6948 9.96063 14.0373 8.30313 12 8.30313Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.19bcf74a6e349c205c419a8982ba9a27.svg";
export { ForwardRef as ReactComponent };